export default __webpack_public_path__ + "static/logo_text_black-cc3a26a24d7c158810bddb8568eb2d91.svg";